import { render, staticRenderFns } from "./downShopHouseManage.vue?vue&type=template&id=4e48c5c5&scoped=true"
import script from "./downShopHouseManage.vue?vue&type=script&lang=js"
export * from "./downShopHouseManage.vue?vue&type=script&lang=js"
import style0 from "./downShopHouseManage.vue?vue&type=style&index=0&id=4e48c5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48c5c5",
  null
  
)

export default component.exports